import { Label, Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/shared/ui/primitives'
import { cn } from '@/shared/ui/cn'

type FormSelectProps = {
  id: string
  label: string
  value: string
  onChange: (value: string) => void
  options: Array<{ value: string; label: string }>
  error?: string
  required?: boolean
  disabled?: boolean
  placeholder?: string
  className?: string
}

function FormSelect({
  id,
  label,
  value,
  onChange,
  options,
  error,
  required,
  disabled,
  placeholder,
  className,
}: FormSelectProps) {
  return (
    <div className={cn('grid gap-2', className)}>
      <Label htmlFor={id}>
        {label}
        {required ? ' *' : null}
      </Label>
      <Select value={value} onValueChange={onChange} disabled={disabled}>
        <SelectTrigger
          id={id}
          aria-label={label}
          aria-invalid={!!error}
          aria-describedby={error ? `${id}-error` : undefined}
        >
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {options.map((o) => (
            <SelectItem key={o.value} value={o.value}>
              {o.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {error ? (
        <p id={`${id}-error`} className="text-sm text-destructive">
          {error}
        </p>
      ) : null}
    </div>
  )
}

export { FormSelect }
export type { FormSelectProps }
